import React, { useState, useEffect, useRef } from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText, Grid, CardMedia, Typography, 
  ListItemButton} from "@mui/material";
import { MediaPlayer, MediaProvider, Poster } from "@vidstack/react";
import {  defaultLayoutIcons,  DefaultVideoLayout} from "@vidstack/react/player/layouts/default";
import "react-image-gallery/styles/css/image-gallery.css";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import Tooltip from "@mui/material/Tooltip";
// import CenterModeVideo from "../utilities/centerModeVideoSlider";
import { Box,  useMediaQuery } from "@mui/system";
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/HomePage.scss";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import '@vidstack/react/player/styles/default/layouts/audio.css';
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

// import "./index.scss";
import "../../styles/new_design.scss";
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const UPLOAD_MYVIDEO__URL = import.meta.env.VITE_UPLOAD_MYVIDEO__URL;



// for videos
interface VideoData {
  id: number;
  src: string;
  title: string;
  poster: string;
}

// constants/videos.ts
export const mediaList = {
  videos: [
    {
      id: 1,
      title: "Clinical Visuals",
      src: "demos/Generic_DEMO.mp4",
      poster: "animations/images/common_cold.webp",
    },
    {
      id: 2,
      title: "ENT",
      src: "demos/ENT_DEMO.mp4",
      poster: "animations/images/hoarseness.webp",
    },
    {
      id: 3,
      title: "Gynaecology",
      src: "demos/Gynac_DEMO.mp4",
      poster: "animations/images/90002003.webp",
    },
  ],
};
  
  

const CustomDemosDesign: React.FC = () => {
  const [showVideoSlider, setShowVideoSlider] = useState<boolean>(true);
  const sliderRef = useRef<Slider | null>(null); // Reference for the slider
  const videoRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<number>(0);
  const isMobile = useMediaQuery("(max-width:820px)");
  const [autoPlay, setAutoPlay] = useState(false);
  const videos: VideoData[] = mediaList.videos || [];
  // const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [activeId, setActiveId] = useState<number>(mediaList.videos[0].id);
  // const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [videoList, setVideoList] = useState(mediaList.videos);

console.log("videos", Object.keys(mediaList).length);

  // Videos Scroll
  useEffect(() => {
    if (videoRefs.current[selectedVideo]) {
      videoRefs.current[selectedVideo].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedVideo]);
  // Videos Click function
  // const handleVideoClick = (videoIndex: number) => {
  //   console.log("videoIndex", videoIndex);
    
  
  
  //   if (sliderRef.current) {
  //     setSelectedVideo(videoIndex);
  //     sliderRef.current.slickGoTo(videoIndex); // Navigate to the selected video
  //     setAutoPlay(true);
  //   }
  // };
    
  // Videos click to highlight secion

  const totalVideos = videos.length;
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (showVideoSlider) {
        const currentIndex: number = Number(selectedVideo);

        if (event.keyCode === 39) {
          // Right arrow key
          if (sliderRef.current) {
            if (currentIndex === totalVideos - 1) {
              sliderRef.current.slickGoTo(0);
              setSelectedVideo(0);
            } else {
              sliderRef.current.slickNext();
              setSelectedVideo(currentIndex + 1);
            }
          }
        } else if (event.keyCode === 37) {
          // Left arrow key
          if (sliderRef.current) {
            if (currentIndex === 0) {
              sliderRef.current.slickGoTo(totalVideos - 1);
              setSelectedVideo(totalVideos - 1);
            } else {
              sliderRef.current.slickPrev();
              setSelectedVideo(currentIndex - 1);
            }
          }
        }
      }
    };

    const handleClickNext = () => {
      if (sliderRef.current) {
        const currentIndex: number = Number(selectedVideo);
        if (currentIndex === totalVideos - 1) {
          sliderRef.current.slickGoTo(0);
          setSelectedVideo(0);
        } else {
          sliderRef.current.slickNext();
          setSelectedVideo(currentIndex + 1);
        }
      }
    };

    const handleClickPrev = () => {
      if (sliderRef.current) {
        const currentIndex: number = Number(selectedVideo);
        if (currentIndex === 0) {
          sliderRef.current.slickGoTo(totalVideos - 1);
          setSelectedVideo(totalVideos - 1);
        } else {
          sliderRef.current.slickPrev();
          setSelectedVideo(currentIndex - 1);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    const nextButton = document.querySelector(".slick-arrow.slick-next");
    const prevButton = document.querySelector(".slick-arrow.slick-prev");

    if (nextButton) {
      nextButton.addEventListener("click", handleClickNext);
    }

    if (prevButton) {
      prevButton.addEventListener("click", handleClickPrev);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (nextButton) {
        nextButton.removeEventListener("click", handleClickNext);
      }
      if (prevButton) {
        prevButton.removeEventListener("click", handleClickPrev);
      }
    };
  }, [showVideoSlider, selectedVideo, totalVideos]);


  // Video icon Function
  const handleVidCardClick = () => {
    setShowVideoSlider(true);
  };
    
  // Video Settings
  const settings2 = {
    className: "videogallery",
    dots: false,
    arrows: false,
    autoplay: false,
    infinite: false,
    fade: true,
    speed: 10,
    adaptiveHeight: true,
    swipe: true,
    draggable: false,
    ref: (slider: any) => (sliderRef.current = slider),
    afterChange: (index: number) => {
      const container = document.querySelectorAll(".carouselvideo");
      container.forEach((carousel, i) => {
        const allPlayers = carousel.querySelector("video") as HTMLVideoElement;
        if (i !== index) {
          allPlayers.pause();
        } else {
          allPlayers.play();
        }
      });
    },
  };
  console.log("newList", videoList);
  console.log("selectedVideo:", selectedVideo);
  const handleClick = (index: number, src: string) => {
    setSelectedVideo(index);
    console.log("index", src);
    
    const selected = videoList[index];

    // Move clicked item to 0th index
    const newList = [selected, ...videoList.filter((_, i) => i !== index)];
    setVideoList(newList);
    console.log("newList", newList);
    

    // Set activeId to newly selected video
    setActiveId(newList[0].id);
    console.log("newList[0].id", newList[0].id);
    
   
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);

    setAutoPlay(true);

    console.log("selectedVideo:", selectedVideo);
  };

  return (
    <Grid className="approot new_design" sx={{ mt: 3 }}>
      <Grid container sx={{}} className="contentMain">
        {Object.keys(mediaList).length > 1 ? (
          <Grid
            container
            item
            spacing={-8}
            // spacing={!isMobile ? -8 : 0}
            marginLeft={0}
            xs={12}
            md={1}
            lg={1}
            sm={12}
            className="buttonPanel"
            pr={2}
            sx={{
              flexDirection: {
                xs: "row",
                md: "column",
              },
              justifyContent: {
                xs: "space-around",
                md: "center",
              },

              marginTop: {
                xs: 0,
                md: 0,
              },
            }}
          >
            <Box
              letterSpacing={1}
              sx={{
                flexDirection: {
                  xs: "row", // horizontal on mobile
                  md: "column", // vertical on larger screens
                },
                display: "flex", // Ensure flexbox layout
                justifyContent: "center", // Optional: Center content horizontally
                alignItems: "center", // Optional: Align items to the center
                gap: { xs: 2, md: 0 }, // Optional: Adjust spacing between items
              }}
            >
              {videos.length > 0 && (
                <Box
                  marginBottom={{ xs: 0, md: 2 }}
                  marginTop={{ xs: 0, md: 2 }}
                >
                  <Tooltip title="Video" placement="right-start" arrow>
                    <VideocamRoundedIcon
                      fontSize="large"
                      className="displayCategory"
                      onClick={handleVidCardClick}
                      sx={{
                        backgroundColor: showVideoSlider ? "transparent" : "",
                        color: showVideoSlider ? "#fff" : "#8d8d8d",
                        borderRadius: showVideoSlider ? "5px" : "",
                        width: showVideoSlider ? "50px" : "40px",
                      }}
                    />
                  </Tooltip>
                </Box>
              )}
            </Box>
          </Grid>
        ) : (
          <Grid
            container
            item
            spacing={-8}
            // spacing={!isMobile ? -8 : 0}
            marginLeft={0}
            xs={12}
            md={1}
            lg={1}
            sm={12}
            pr={2}
            sx={{
              flexDirection: {
                xs: "row",
                md: "column",
              },
              justifyContent: {
                xs: "space-around",
                md: "center",
              },

              marginTop: {
                xs: 0,
                md: 0,
              },
            }}
          ></Grid>
        )}

        {/* Videos Section Starts */}
        {showVideoSlider && (
          <Grid
            className="design_back"
            container
            item
            marginLeft={3}
            mt={4}
            xs={12}
            md={11}
            sm={12}
            sx={{
              background: "#fff",
            }}
          >
            {/* Horizontal Slider */}
            <Grid
              // container
              item
              marginLeft={3}
              marginRight={4}
              xs={12}
              md={2}
              lg={2}
              sm={12}
              className="horizontal_section"
              sx={{
                height: "85vh",
                overflowY: "auto",
                // flexDirection: {
                //   xs: "row",
                //   md: "column",
                // },
                display: {
                  xs: "contents",
                  md: "flex",
                },
                paddingTop: 0,
                marginTop: 1,
              }}
            >
              {showVideoSlider && !isMobile && (
                <Grid
                  item
                  xs={12}
                  md={9}
                  sx={{
                    flexDirection: {
                      xs: "row",
                      md: "column",
                    },
                    display: {
                      xs: "contents",
                      md: "flex",
                    },
                  }}
                >
                  {videoList.map((video, index) => (
                    <div
                      key={video.id}
                      ref={(el) => (videoRefs.current[index] = el)} // Store the ref for each image
                      onClick={() => handleClick(index, video.src)} // Handle click event
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <CardMedia
                          key={video.id}
                          sx={{
                            width: "100%",
                            aspectRatio: "1.3/ 1",
                            objectFit: "fill !important",
                            marginBottom: "12%",
                            filter:
                              video.id === activeId
                                ? "brightness(50%)"
                                : "none",
                            borderRadius:
                              video.id === activeId ? "15px" : "none",
                          }}
                          component="img"
                          className="vid_sec"
                          // onClick={() => handleVideoClick(index)}
                          image={UPLOAD_MYVIDEO__URL + video.poster}
                          alt="Demo Image"
                        />
                        {video.id === activeId && (
                          <ArrowForwardIosOutlinedIcon
                            className="active_img"
                            sx={{ marginLeft: "5px", color: "#1976d2" }}
                          />
                        )}
                      </Box>
                      <Typography
                        className="name"
                        sx={{
                          marginBottom: "12%",
                          textAlign: "center",
                          marginTop: "5px",
                          fontWeight: "600",
                        }}
                      >
                        {/* {video.title} */}
                        {video.title.length <= 22
                          ? video.title
                          : video.title.substr(0, 22) + "..."}
                      </Typography>
                    </div>
                  ))}
                </Grid>
              )}
              {showVideoSlider && isMobile && (
                // <CenterModeVideo
                //   videos={videos}
                //   selectedvideos={selectedVideo}
                //   handleVideoClick={handleVideoClick}
                // />
                <>
                  <List>
                    {/* <Typography> My Videos</Typography> */}
                    {videoList.map((video, index) => (
                      <ListItem key={video.id} disablePadding>
                        <ListItemButton
                          onClick={() => handleClick(index, video.src)}
                          sx={{
                            mb: 1,
                            borderRadius: 2,
                            backgroundColor:
                              video.id === activeId ? "" : "#f5f5f5",
                            boxShadow: video.id === activeId ? 3 : 1,
                            border:
                              video.id === activeId
                                ? "2px solid #1976d2"
                                : "2px solid transparent",
                            transition: "all 0.3s ease",
                          }}
                        >
                          <ListItemAvatar>
                            <Avatar
                              variant="rounded"
                              src={UPLOAD_MYVIDEO__URL + video.poster}
                              alt={video.title}
                              sx={{ width: 100, height: 60, mr: 2 }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={video.title}
                            primaryTypographyProps={{
                              fontSize: 14,
                              fontWeight: 500,
                            }}
                          />
                          <PlayArrowIcon color="action" />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </>
              )}
            </Grid>
            <Grid
              item
              marginLeft={4}
              marginRight={4}
              mt={0}
              xs={12}
              md={8}
              lg={9}
              sm={12}
              className="img_view_section"
            >
              {showVideoSlider && (
                <Grid>
                  <Slider {...settings2} className="videogallery">
                    {/* {videos.map((video: VideoData) => ( */}
                    {videoList[0] && (
                      <MediaPlayer
                        key={videoList[0].id}
                        id={`videoslider${videoList[0].id}`}
                        className="carouselvideo"
                        src={VISUALIZE__URL + videoList[0].src}
                        viewType="video"
                        streamType="on-demand"
                        logLevel="warn"
                        crossOrigin
                        playsInline
                        autoPlay={autoPlay}
                        title={videoList[0].title}
                        poster={UPLOAD_MYVIDEO__URL + videoList[0].poster}
                      >
                        <MediaProvider>
                          <Poster className="vds-poster" />
                        </MediaProvider>
                        <DefaultVideoLayout icons={defaultLayoutIcons} />
                      </MediaPlayer>
                    )}
                  </Slider>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {/* Videos Section End */}
      </Grid>
    </Grid>
  );
};
export default CustomDemosDesign;
